import './HelpNode.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { List, Icon } from 'semantic-ui-react';
import { some } from 'lodash';

class RootHelpNode extends React.Component {
  static propTypes = {
    children: PropTypes.array,
    onExpand: PropTypes.func,
    title: PropTypes.string,
  };

  static defaultProps = {
    onExpand: () => {},
  };

  constructor(props) {
    super(props);

    const hasSelectedChild = some(props.children, childNode => childNode.props.isSelected);
    this.state = {
      expanded: hasSelectedChild,
    };

    this.handleTitleSelect = this.handleTitleSelect.bind(this);
  }

  handleTitleSelect() {
    this.setState(prevState => ({ expanded: !prevState.expanded }));

    // Force help nav to update its sticky positioning, which prevents
    // the expansion of topic nodes beyond the bottom of the page.
    window.scrollBy(0, -1);
    window.scrollBy(0, 1);

    this.props.onExpand();
  }

  render() {
    const style = this.state.expanded ? null : { display: 'none' };
    const iconName = this.state.expanded ? 'triangle down' : 'triangle right';
    return (
      <div>
        <List>
          <List.Item className="aa-help-node-root" onClick={this.handleTitleSelect}>
            <Icon name={iconName} color="teal" />
            { this.props.title }
          </List.Item>
          <List.List style={style} className="aa-help-node">
            { this.props.children }
          </List.List>
        </List>
      </div>
    );
  }
}

export default RootHelpNode;
